import { ErrorLevel } from 'app/lib/constants';
import {
    AMBIGUOUS_COLUMN_REFERENCE,
    COMPILATION_FAILED_WITH_DATASET_ERROR,
    COMPILATION_FAILED_WITH_TRANSFORMATION_ERRORS,
    INVALID_IDENTIFIER,
    UNEXPECTED_FAILURE
} from 'app/store/__generated__/errors';
import type { GeneratedBackendErrors } from './types.js';
import { CUSTOM_TRANSFORMATION_ERRORS } from './constants';

export function getErrorLevelFallback(errorName: GeneratedBackendErrors): ErrorLevel {
    switch (errorName) {
        case AMBIGUOUS_COLUMN_REFERENCE:
        case COMPILATION_FAILED_WITH_DATASET_ERROR:
        case COMPILATION_FAILED_WITH_TRANSFORMATION_ERRORS:
        case CUSTOM_TRANSFORMATION_ERRORS:
        case INVALID_IDENTIFIER:
        case UNEXPECTED_FAILURE:
            return ErrorLevel.ERROR;
        default:
            return ErrorLevel.WARNING;
    }
}
